import { Component } from "@angular/core";

@Component({
  selector: "cla-vehicles-container",
  templateUrl: "./vehicles-container.component.html",
  styleUrls: ["./vehicles-container.component.scss"],
  standalone: false,
})
export class VehiclesContainerComponent {}
